<template>
  <SelectWithSearch
    label="Responsável Retenção"
    placeholder="Selecione o responsável"
    v-model="input"
    :disabled="disabled"
    :clearable="clearable"
    :change="change"
    :options="responsibleRetentionCollection"
    :filterBy="descriptionFilter"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.description }}</div>
    </template>
    <template slot="no-options"> Selecione um responsável </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.description }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectResponsibleRetention',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    default: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {},
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setResponsibleRetentionCollection();

    if (this.default && !this.input) {
      const defaultOption = this.responsibleRetentionCollection[3];
      this.$emit('input', defaultOption);
    }
  },
  computed: {
    ...mapState('fiscalComponents', ['responsibleRetentionCollection']),
  },
  methods: {
    ...mapActions('fiscalComponents', ['setResponsibleRetentionCollection']),

    change(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
